import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { AppProvider } from "./contexts/AppContext";
import { AchievementProvider } from "./contexts/AchievementContext";
import Layout from "./components/Layout";
import { MetaData } from "./components/MetaData";
import Home from "./pages/Home";
import Tasks from "./pages/Tasks";
import Calendar from "./pages/Calendar";
import Reminders from "./pages/Reminders";
import CreateTask from "./pages/CreateTask";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "sonner";
import Grocery from '@/pages/Grocery';
import Auth from '@/pages/Auth';
import { useApp } from './contexts/AppContext';
import { ProtectedRoute } from '@/components/ProtectedRoute';

const queryClient = new QueryClient();

function AppRoutes() {
  const { user } = useApp();

  return (
    <Routes>
      <Route path="/auth" element={
        user ? <Navigate to="/" /> : <Auth />
      } />
      
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout>
              <Outlet />
            </Layout>
          </ProtectedRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="tasks" element={<Tasks />} />
        <Route path="calendar" element={<Calendar />} />
        <Route path="reminders" element={<Reminders />} />
        <Route path="create" element={<CreateTask />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <AchievementProvider>
            <TooltipProvider>
              <MetaData />
              <Toaster />
              <Sonner position="top-center" />
              <Router>
                <AppRoutes />
              </Router>
            </TooltipProvider>
          </AchievementProvider>
        </AppProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
